
export function StatCard({ label, value, mono = false, icon: Icon, testid }) {
  return (
    <div
      data-testid={testid}
      className="bg-white border border-slate-200 rounded-lg p-6 flex items-start justify-between"
    >
      <div>
        <p className="label-overline text-slate-500">{label}</p>
        <p
          className={`mt-3 text-3xl font-semibold text-slate-900 ${
            mono ? "font-mono-num" : "font-display"
          }`}
        >
          {value}
        </p>
      </div>
      {Icon && (
        <div className="h-10 w-10 rounded-md border border-slate-200 bg-slate-50 flex items-center justify-center text-slate-700">
          <Icon className="h-5 w-5" />
        </div>
      )}
    </div>
  );
}
